import { retrieveObjectMapper } from '../..';

export const transformCurrentSystemAnnouncementByTarget = (
  announcementData = {},
  targetMappingsData = [],
  targetsData = []
) => {
  if (!announcementData || !announcementData.id) {
    return {
      getCurrentSystemAnnouncementV2: null,
    };
  }

  const targetsMap = {};
  targetsData.forEach(target => {
    if (target.id) {
      targetsMap[target.id] = retrieveObjectMapper(target, [
        'ID:id',
        'name',
        'displayName:display_name',
      ]);
    }
  });

  const systemAnnouncementTargetMappings = {
    data: targetMappingsData.map(mapping => {
      const targetId = mapping.fk_target;

      return {
        ID: mapping.id,
        systemAnnouncementTarget: targetsMap[targetId] || null,
      };
    }),
  };

  return {
    getCurrentSystemAnnouncementV2: {
      ...retrieveObjectMapper(announcementData, [
        'ID:id',
        'title',
        'message',
        'from',
        'to',
      ]),
      systemAnnouncementTargetMappings,
    },
  };
};

export const transformAllSystemAnnouncementTargets = (targetsData = []) => {
  return {
    data: (targetsData || []).map(target =>
      retrieveObjectMapper(target, [
        'ID:id',
        'name',
        'displayName:display_name',
        'active',
      ])
    ),
  };
};

export const transformAllSystemAnnouncements = (
  announcementsData = [],
  targetMappingsData = [],
  targetsData = [],
  totalCount = 0
) => {
  if (!announcementsData || announcementsData.length === 0) {
    return {
      data: [],
      totalCount: 0,
    };
  }

  const mappingsByAnnouncementId = {};
  targetMappingsData.forEach(mapping => {
    const announcementId = mapping.fk_announcement;
    if (!mappingsByAnnouncementId[announcementId]) {
      mappingsByAnnouncementId[announcementId] = [];
    }
    mappingsByAnnouncementId[announcementId].push(mapping);
  });

  const targetsMap = {};
  targetsData.forEach(targetItem => {
    if (targetItem.id) {
      targetsMap[targetItem.id] = retrieveObjectMapper(targetItem, [
        'ID:id',
        'name',
        'displayName:display_name',
      ]);
    }
  });

  const transformedData = {
    data: announcementsData.map(announcement => {
      const announcementMappings =
        mappingsByAnnouncementId[announcement.id] || [];

      return {
        ...retrieveObjectMapper(announcement, [
          'ID:id',
          'title',
          'message',
          'from',
          'to',
          'fkSchool:fk_school',
          'createdAt:created_at',
          'updatedAt:updated_at',
        ]),
        systemAnnouncementTargetMappings: {
          data: announcementMappings.map(mapping => {
            const targetId = mapping.fk_target;
            return {
              ID: mapping.id,
              systemAnnouncementTarget: targetsMap[targetId] || null,
            };
          }),
        },
      };
    }),
  };

  return {
    ...transformedData,
    totalCount: totalCount || transformedData.data.length,
  };
};

export default {
  transformCurrentSystemAnnouncementByTarget,
  transformAllSystemAnnouncementTargets,
  transformAllSystemAnnouncements,
};
